import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableRow,
    Grid,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Chip,
    Typography,
} from "@material-ui/core";
import { useStyles } from "../../adminStyles";

const CommentDialogue = props => {
    const {
        dialogTitleContainer,
        chip,
        chipLabel,
        btn,
        dialogTitle,
    } = useStyles();

    const { commentOpen, handleCommentClose, commentColumns, userObj } = props;

    const renderTableBody = () => {
        const userComments = userObj.comments;

        return (
            userObj &&
            userComments && (
                <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={Math.random()}
                >
                    {commentColumns.map(column => {
                        return (
                            <TableCell key={column.id} align={column.align}>
                                {column.id === "comment" ? userComments : null}
                            </TableCell>
                        );
                    })}
                </TableRow>
            )
        );
    };

    return (
        <Dialog
            open={commentOpen}
            onClose={handleCommentClose}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"md"}
        >
            <DialogTitle
                id="form-dialog-title"
                className={dialogTitleContainer}
            >
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                >
                    <Typography variant="h5" className={dialogTitle}>
                        Name: {userObj.name}
                    </Typography>
                    <div>
                        <Grid
                            item
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                        >
                            <h5 className={chipLabel}>Vacation</h5>
                            <Chip label={userObj.vacation} className={chip} />
                            <h5 className={chipLabel}>Holiday</h5>
                            <Chip label={userObj.holiday} className={chip} />
                            <h5 className={chipLabel}>Sick</h5>
                            <Chip label={userObj.sick} className={chip} />
                        </Grid>
                    </div>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Table>
                    <TableBody>
                        {!userObj.details ? (
                            <div>loading</div>
                        ) : (
                            renderTableBody()
                        )}
                    </TableBody>
                </Table>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button
                    onClick={handleCommentClose}
                    color="primary"
                    className={btn}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CommentDialogue;
